var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClubsSociety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8936 31.6325C33.4276 31.6325 33.9616 31.4209 34.3887 31.2093C34.8159 31.4209 35.3499 31.6325 35.8839 31.6325C37.2722 31.6325 38.3402 30.6804 38.3402 29.4108V22.3227C39.1946 22.0053 39.9421 21.1589 39.9421 20.101V14.1766C39.9421 12.5897 38.6606 11.2144 37.0586 11.2144H31.8256C30.2237 11.2144 28.9421 12.5897 28.9421 14.1766V20.101C28.9421 21.1589 29.5829 22.0053 30.5441 22.3227V29.4108C30.4373 30.6804 31.612 31.6325 32.8936 31.6325ZM33.4276 29.4108C33.4276 29.5166 33.214 29.7282 32.8936 29.7282C32.5732 29.7282 32.3596 29.5166 32.3596 29.4108V21.4763C32.3596 20.9474 31.9324 20.5242 31.3984 20.5242H31.2917C31.0781 20.5242 30.8645 20.3126 30.8645 20.101V14.1766C30.8645 13.6476 31.2917 13.1186 31.7188 13.1186H36.9518C37.4858 13.1186 37.8062 13.5418 37.8062 14.1766V20.101C37.8062 20.3126 37.5926 20.5242 37.379 20.5242H37.2722C36.7383 20.5242 36.3111 20.9474 36.3111 21.4763V29.4108C36.3111 29.5166 36.0975 29.7282 35.7771 29.7282C35.4567 29.7282 35.2431 29.5166 35.2431 29.4108V22.8516C35.2431 22.3227 34.8159 21.8995 34.2819 21.8995C33.748 21.8995 33.3208 22.3227 33.3208 22.8516V29.4108H33.4276Z",
    fill: "url(#paint0_linear_91_6376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3889 10.5795C36.2044 10.5795 37.5928 9.09843 37.5928 7.40574C37.5928 5.60725 36.0976 4.23193 34.3889 4.23193C32.5734 4.23193 31.185 5.71304 31.185 7.40574C31.185 9.20423 32.5734 10.5795 34.3889 10.5795ZM34.3889 6.24201C35.0297 6.24201 35.6704 6.77098 35.6704 7.51153C35.6704 8.14629 35.1365 8.78105 34.3889 8.78105C33.7481 8.78105 33.1073 8.25209 33.1073 7.51153C33.1073 6.77098 33.7481 6.24201 34.3889 6.24201Z",
    fill: "url(#paint1_linear_91_6376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2909 31.6321C20.9317 31.6321 21.5725 31.4206 21.9997 31.1032C22.4269 31.4206 23.0676 31.6321 23.7084 31.6321C25.2036 31.6321 26.3783 30.5742 26.3783 29.1989V20.7354C27.4463 20.418 28.1938 19.3601 28.1938 18.3022V11.4256C28.1938 9.6271 26.8055 8.146 24.99 8.146H18.9026C17.1938 8.146 15.6987 9.6271 15.6987 11.4256V18.3022C15.6987 19.4659 16.4463 20.418 17.5142 20.7354V29.1989C17.621 30.5742 18.7958 31.6321 20.2909 31.6321ZM21.0385 29.1989C21.0385 29.4105 20.7181 29.6221 20.2909 29.6221C19.8638 29.6221 19.5434 29.4105 19.5434 29.1989V19.8891C19.5434 19.3601 19.1162 18.9369 18.5822 18.9369H18.3686C18.0482 18.9369 17.7278 18.6195 17.7278 18.3022V11.4256C17.7278 10.685 18.2618 10.0503 18.9026 10.0503H24.99C25.6307 10.0503 26.1647 10.685 26.1647 11.4256V18.3022C26.1647 18.6195 25.8443 18.9369 25.5239 18.9369H25.3104C24.7764 18.9369 24.3492 19.3601 24.3492 19.8891V29.1989C24.3492 29.4105 24.0288 29.6221 23.6016 29.6221C23.1744 29.6221 22.854 29.4105 22.854 29.1989V21.5818C22.854 21.0528 22.4269 20.6296 21.8929 20.6296C21.3589 20.6296 20.9317 21.0528 20.9317 21.5818V29.1989H21.0385Z",
    fill: "url(#paint2_linear_91_6376)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 7.19395C24.0289 7.19395 25.6309 5.60705 25.6309 3.59698C25.6309 1.5869 24.0289 0 21.9998 0C19.9707 0 18.3687 1.5869 18.3687 3.59698C18.3687 5.60705 19.9707 7.19395 21.9998 7.19395ZM21.9998 2.11587C22.8542 2.11587 23.6017 2.85642 23.6017 3.70277C23.6017 4.54912 22.8542 5.28967 21.9998 5.28967C21.1454 5.28967 20.3978 4.54912 20.3978 3.70277C20.3978 2.75063 21.1454 2.11587 21.9998 2.11587Z",
    fill: "url(#paint3_linear_91_6376)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11674 31.6325C8.65072 31.6325 9.1847 31.4209 9.61189 31.2093C10.0391 31.5267 10.5731 31.6325 11.107 31.6325C12.4954 31.6325 13.5633 30.6804 13.5633 29.4108V22.3227C14.4177 22.0053 15.1653 21.1589 15.1653 20.101V14.1766C15.1653 12.5897 13.8837 11.2144 12.2818 11.2144H7.04878C5.44684 11.2144 4.16528 12.5897 4.16528 14.1766V20.101C4.16528 21.1589 4.80606 22.0053 5.76723 22.3227V29.4108C5.66043 30.6804 6.83519 31.6325 8.11674 31.6325ZM8.65072 29.4108C8.65072 29.5166 8.43713 29.7282 8.11674 29.7282C7.79635 29.7282 7.58276 29.5166 7.58276 29.4108V21.4763C7.58276 20.9474 7.15557 20.5242 6.62159 20.5242H6.5148C6.30121 20.5242 6.08761 20.3126 6.08761 20.101V14.1766C6.08761 13.6476 6.5148 13.1186 6.94199 13.1186H12.175C12.709 13.1186 13.0294 13.5418 13.0294 14.1766V20.101C13.0294 20.3126 12.8158 20.5242 12.6022 20.5242H12.4954C11.9614 20.5242 11.5342 20.9474 11.5342 21.4763V29.4108C11.5342 29.5166 11.3206 29.7282 11.0002 29.7282C10.6798 29.7282 10.4663 29.5166 10.4663 29.4108V22.8516C10.4663 22.3227 10.0391 21.8995 9.50509 21.8995C8.97111 21.8995 8.54393 22.3227 8.54393 22.8516V29.4108H8.65072Z",
    fill: "url(#paint4_linear_91_6376)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61155 10.5793C11.4271 10.5793 12.8154 9.09819 12.8154 7.40549C12.8154 5.607 11.3203 4.23169 9.61155 4.23169C7.79601 4.23169 6.40766 5.7128 6.40766 7.40549C6.40766 9.20398 7.79601 10.5793 9.61155 10.5793ZM9.61155 6.24176C10.2523 6.24176 10.8931 6.77073 10.8931 7.51129C10.8931 8.14605 10.3591 8.78081 9.61155 8.78081C8.97077 8.78081 8.32999 8.25184 8.32999 7.51129C8.32999 6.77073 8.86397 6.24176 9.61155 6.24176Z",
    fill: "url(#paint5_linear_91_6376)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41.9999C34.3883 41.9999 44 37.9798 44 32.9017C44 30.3626 41.7573 28.141 37.699 26.4483C37.165 26.2367 36.6311 26.4483 36.4175 26.9772C36.2039 27.5062 36.4175 28.0352 36.9515 28.2468C40.1553 29.6221 42.0777 31.3148 42.0777 32.9017C42.0777 36.2871 33.8544 39.9898 22 39.9898C10.1456 39.9898 1.92233 36.1813 1.92233 32.9017C1.92233 31.3148 3.73786 29.6221 7.04854 28.2468C7.58252 28.0352 7.79612 27.5062 7.58252 26.9772C7.36893 26.4483 6.83495 26.2367 6.30097 26.4483C2.24271 28.141 1.16108e-06 30.3626 1.16108e-06 32.9017C1.16108e-06 37.9798 9.61165 41.9999 22 41.9999Z",
    fill: "url(#paint6_linear_91_6376)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5047 26.66C31.9319 26.66 32.3591 26.3426 32.4659 25.9194C32.5727 25.3905 32.2523 24.8615 31.7183 24.7557C29.796 24.3325 27.66 24.1209 25.5241 24.0151C24.9901 24.0151 24.563 24.4383 24.4562 24.9673C24.4562 25.4962 24.8833 25.9194 25.4173 26.0252C27.4464 26.131 29.4756 26.4484 31.2911 26.7658C31.2911 26.66 31.3979 26.66 31.5047 26.66Z",
    fill: "url(#paint7_linear_91_6376)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4952 26.6601C12.602 26.6601 12.602 26.6601 12.7087 26.6601C14.5243 26.3427 16.5534 26.0253 18.5825 25.9195C19.1165 25.9195 19.5437 25.3905 19.5437 24.8616C19.5437 24.3326 19.0097 23.9094 18.4757 23.9094C16.3398 24.0152 14.2039 24.3326 12.2816 24.65C11.7476 24.7558 11.4272 25.2847 11.534 25.8137C11.6408 26.3427 12.068 26.6601 12.4952 26.6601Z",
    fill: "url(#paint8_linear_91_6376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_6376",
    x1: 34.7362,
    y1: -11.0545,
    x2: 16.2536,
    y2: 14.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_91_6376",
    x1: 34.5602,
    y1: -2.69104,
    x2: 30.4919,
    y2: 7.82837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_6376",
    x1: 22.2803,
    y1: -17.469,
    x2: 0.938901,
    y2: 11.6136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_91_6376",
    x1: 22.1939,
    y1: -7.84604,
    x2: 17.5832,
    y2: 4.07596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_91_6376",
    x1: 9.95935,
    y1: -11.0545,
    x2: -8.52322,
    y2: 14.4501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_91_6376",
    x1: 9.78285,
    y1: -2.69129,
    x2: 5.71454,
    y2: 7.82812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_91_6376",
    x1: 23.1763,
    y1: 9.31746,
    x2: 19.1233,
    y2: 38.5371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_91_6376",
    x1: 28.6859,
    y1: 21.0152,
    x2: 27.9975,
    y2: 26.1633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_91_6376",
    x1: 15.7433,
    y1: 20.9095,
    x2: 15.0548,
    y2: 26.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubsSociety);
export default __webpack_public_path__ + "static/media/Clubs & Society.fd2ea7458b01599e372fb3f83c74001e.svg";
export { ForwardRef as ReactComponent };